import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

function editPaymentMethod(data, sellerId, token) {
  const url = `${apiUrl}/sellers/${sellerId}/payment-method`;

  return request(url, token, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function fetchSetupIntent(sellerId, token) {
  const url = `${apiUrl}/sellers/${sellerId}/setup-intent`;

  return request(url, token);
}

export { editPaymentMethod, fetchSetupIntent };
